import AlertCard from "./alert-card";

export default AlertCard;
